module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Hcp"
    }
  }, [_c('div', {
    staticClass: "Hcp-header",
    class: {
      'de1': _vm.isDe, 'es1': _vm.isEs, 'po2': _vm.isPo || _vm.isDu || _vm.isFr
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    staticClass: "menu-left",
    class: {
      'isM': !_vm.notM
    }
  }, [_c('div', {
    staticClass: "menu-item1",
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/menu/normal/Home.png")
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }]
  }, [_vm._v(_vm._s(_vm.$t('pList')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notM),
      expression: "!notM"
    }]
  }, [_vm._v(_vm._s(_vm.$t('connections')))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-right",
    class: {
      'personal': !_vm.isHcp, 'es2': _vm.isEs
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    staticClass: "menu-item3 menu-spe3",
    class: {
      'item-choose': _vm.isG
    },
    on: {
      "click": _vm.changeMenu7
    }
  }, [_c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.patientName))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item3 per-item3",
    class: {
      'item-choose': _vm.isA, 'isM1': !_vm.notM
    },
    on: {
      "click": _vm.changeMenu1
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/normal/chart setting.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/highlight/chart setting_c.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item3 menu-spe2",
    class: {
      'item-choose': _vm.isB, 'isM1': !_vm.notM
    },
    on: {
      "click": _vm.changeMenu2
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/highlight/monitor_c.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isB),
      expression: "!isB"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/normal/monitor.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('monitor')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isC, 'isM2': !_vm.notM
    },
    on: {
      "click": _vm.changeMenu3
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/highlight/Graphs_c.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isC),
      expression: "!isC"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/normal/graphs.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('graphs')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }],
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isE
    },
    on: {
      "click": _vm.changeMenu5
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/highlight/records_c.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isE),
      expression: "!isE"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/normal/records.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('records')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no),
      expression: "no"
    }],
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isF
    },
    on: {
      "click": _vm.changeMenu6
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isF),
      expression: "isF"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/highlight/quick print_c.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isF),
      expression: "!isF"
    }],
    attrs: {
      "src": require("../assets/Hcp-icon/menu/normal/quick print.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('qPrint')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-container"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n        " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f979cd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCP.vue
// module id = 1458
// module chunks = 7